import { Component, OnInit } from '@angular/core';
import { Submission } from "../../models/submission";
import { SubmissionService } from "../../submission.service";
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';

import 'rxjs/add/operator/mergeMap';

import 'rxjs/add/observable/from';
import 'rxjs/add/operator/startWith';
import { Subject } from "rxjs/Subject";
import 'rxjs/add/operator/catch';
import {MaterializeAction} from 'angular2-materialize';
import { EventEmitter, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";



@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SearchComponent implements OnInit {
  bufferSubmissions : Observable<Submission[]>;
  filteredSubmissions : Observable<Submission[]>;
  isLoading:boolean;
  searchError = false;
  private searchTerm = new Subject<string>();
  selectedSubmission: Submission;
  modalActions = new EventEmitter<string|MaterializeAction>();
  selectedTitle:string;
  selectedAuthor:string;
  lastTerm: string;

  constructor(private service: SubmissionService, private router : Router) { }

  ngOnInit() {

    this.filteredSubmissions = this.searchTerm
      .debounceTime(300)
      .distinctUntilChanged()
      .switchMap(term => 
        {
          let results = this.service.searchSubmissions(term)
          let out = term ? results.map(submission => this.formatResult(submission, term)): Observable.of<Submission[]>([])
          return out
        }
    )
      .catch(error => { 
        this.searchError = true;
        return Observable.of<Submission[]>([])
      });
    this.filteredSubmissions.subscribe(() => this.isLoading = false)
  }

  quickFilter(sub: Submission, term: string): boolean{
    if(sub !== null){
        return (sub.title.toLowerCase().indexOf(term) != -1)[0]
    } 
    return false
  }

  formatResult(submissions: Submission[], term:string): Submission[] {
    if(term){
      let reg = new RegExp(term, 'ig')
      let termTemplate = "<span class='search-term darken-5'>%s</span>";
      submissions.map( submission => {
        submission.title = submission.title.replace(reg, foundTerm => termTemplate.replace('%s', foundTerm));
        submission.author = submission.author.replace(reg, foundTerm => termTemplate.replace('%s', foundTerm));
        submission.shortlink = submission.shortlink.replace(reg, foundTerm => termTemplate.replace('%s', foundTerm));
      })
    }
    return submissions

  }

  
  search(term: string): void{
    this.searchTerm.next(term);
    this.isLoading = true;
    this.searchError = false;
  }

  handleImageError(event: any): void{
    event.target.src = "/assets/reddit404.png"
    event.target.width = 150
    event.target.height = 100
    event.stopPropagation();
  }

  goToDetailPage(id:string) : void{
    let link = ['/s', id];
    this.router.navigate(link);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/home/search/search.component.ts